import Incidents from '@src/main/modules/other_incidents/ui/components/IncidentsView';

const IncidentsPage = () => <Incidents formType="" />;

export default IncidentsPage;
